import { useCallback } from 'react';
import { useRegisterNewAccountByOtp as useRegisterNewAccountByOtpRequest } from '../api/requests';
import type { CustomerToken, RegisterAccountInfo } from '../types/front.graphql';
import { getDeviceInformation } from '@kidslabs/module-core';
import type { ResultData } from '../types';
import { authStore$ } from '../stores/auth.store';
import { ErrorCodesEnum } from '../enums';

export interface RegisterResultData extends ResultData {
    customerToken?: CustomerToken;
}

export const useRegisterNewAccountByOtp = () => {
    const { registerNewAccountByOtp: doRegisterNewAccountByOtp } = useRegisterNewAccountByOtpRequest();

    return useCallback(
        async (accountInfo: RegisterAccountInfo): Promise<RegisterResultData> => {
            const deviceInfo = getDeviceInformation();
            const response = await doRegisterNewAccountByOtp({
                variables: {
                    phoneNumber: authStore$.initValidatePhoneData.get()?.phoneNumber ?? '',
                    otp: authStore$.currentOtp.get() ?? '',
                    secret: authStore$.confirmRequestedValidationPhone.secret.get() ?? 'NO_SECRET',
                    accountInfo,
                    deviceRequest: deviceInfo,
                    referralCode: authStore$.initValidatePhoneData.get()?.referralCode,
                },
            });

            const customerToken = response?.data?.registerNewAccountByOtp?.customer_token;
            if (customerToken?.access_token) {
                return {
                    message: 'Register successful',
                    errorCode: ErrorCodesEnum.SUCCESS,
                    customerToken,
                };
            }

            const errorMessage = response?.errors?.map(e => e.message).join(', ') ?? 'Unable to register';
            return { message: errorMessage, errorCode: ErrorCodesEnum.NOT_FOUND };
        },
        [doRegisterNewAccountByOtp]
    );
};
